(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mouthyukyuk-header-navigation"] && !Shopify.designMode) return;
  try {
    class MouthyukyukHeaderNavigation extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      this.abortController?.abort();
      this.menus?.forEach((menu) => clearTimeout(menu.closeTimer));
    }

    setup() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.menus = Array.from(this.querySelectorAll('header-menu > details')).map((details) => ({
        details,
        summary: details.querySelector(':scope > summary'),
        list: details.querySelector(':scope > ul'),
        closeTimer: null,
      }));

      this.menus.forEach((menu) => {
        menu.list?.classList.toggle('myy-menu--columns', menu.list.children.length > 10);
        menu.details.addEventListener('pointerenter', (event) => {
          if (!this.desktop.matches || !this.hover.matches || event.pointerType !== 'mouse') return;
          clearTimeout(menu.closeTimer);
          this.open(menu);
        }, options);
        menu.details.addEventListener('pointerleave', (event) => {
          if (!this.desktop.matches || !this.hover.matches || event.pointerType !== 'mouse') return;
          menu.closeTimer = setTimeout(() => {
            if (menu.details.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
            this.close(menu);
          }, 180);
        }, options);
        menu.details.addEventListener('focusin', (event) => {
          if (!this.desktop.matches || this.pointerActivation || this.restoringFocus) return;
          if (event.target.matches(':focus-visible')) this.open(menu);
        }, options);
        menu.details.addEventListener('focusout', () => {
          setTimeout(() => {
            if (!menu.details.contains(document.activeElement)) this.close(menu);
          }, 0);
        }, options);
        menu.details.addEventListener('toggle', () => {
          menu.summary.setAttribute('aria-expanded', String(menu.details.open));
          if (menu.details.open) this.position(menu);
          queueMicrotask(() => {
            const header = this.closest('.header-wrapper');
            if (header) header.preventHide = this.menus.some((item) => item.details.open);
          });
        }, options);
      });

      this.addEventListener('pointerdown', () => { this.pointerActivation = true; }, options);
      this.addEventListener('pointerup', () => {
        setTimeout(() => { this.pointerActivation = false; }, 0);
      }, options);
      this.addEventListener('pointercancel', () => { this.pointerActivation = false; }, options);
      this.addEventListener('click', () => {
        setTimeout(() => { this.pointerActivation = false; }, 0);
      }, options);
      this.addEventListener('keydown', (event) => {
        this.pointerActivation = false;
        const menu = this.menus.find((item) => item.details.contains(event.target));
        if (!menu) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.close(menu);
          this.restoringFocus = true;
          menu.summary.focus({ preventScroll: true });
          this.restoringFocus = false;
        } else if (event.target === menu.summary && event.key === 'ArrowDown') {
          event.preventDefault();
          this.open(menu);
          menu.list?.querySelector('a[href]')?.focus();
        }
      }, options);
      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') event.stopPropagation();
      }, { ...options, capture: true });
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.menus.forEach((menu) => this.close(menu));
      }, options);
      window.addEventListener('resize', () => {
        this.menus.forEach((menu) => {
          if (!this.desktop.matches) this.close(menu);
          else if (menu.details.open) this.position(menu);
        });
      }, options);
    }

    open(menu) {
      clearTimeout(menu.closeTimer);
      this.menus.forEach((item) => { if (item !== menu) this.close(item); });
      menu.details.open = true;
      menu.summary.setAttribute('aria-expanded', 'true');
      this.position(menu);
    }

    close(menu) {
      clearTimeout(menu.closeTimer);
      menu.details.querySelectorAll('details[open]').forEach((details) => {
        details.open = false;
        details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });
      menu.details.open = false;
      menu.summary.setAttribute('aria-expanded', 'false');
    }

    position(menu) {
      if (!menu.list || !this.desktop.matches) return;
      menu.list.style.setProperty('--myy-menu-offset', '0px');
      const bounds = menu.list.getBoundingClientRect();
      let offset = Math.min(0, document.documentElement.clientWidth - 16 - bounds.right);
      offset = Math.max(offset, 16 - bounds.left);
      menu.list.style.setProperty('--myy-menu-offset', `${offset}px`);
    }
  }

  if (!customElements.get('mouthyukyuk-header-navigation')) {
    customElements.define('mouthyukyuk-header-navigation', MouthyukyukHeaderNavigation);
  }
  } catch(e) { console.error(e); }
})();

})();
